import { Button } from "devextreme-react/button";

export function WeekNavigator({ dateRange, onWeekChange }) {
  const { startDate, endDate } = dateRange;

  const getStartOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay(); // 0 = Sunday
    const diff = d.getDate() - day;
    const start = new Date(d);
    start.setDate(diff);
    start.setHours(0, 0, 0, 0);
    return start;
  };

  const getEndOfWeek = (start) => {
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
    return end;
  };

  const formatDate = (date) => {
    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const changeWeek = (offset) => {
    const newStart = new Date(startDate);
    newStart.setDate(startDate.getDate() + offset * 7);

    const normalizedStart = getStartOfWeek(newStart);
    const normalizedEnd = getEndOfWeek(normalizedStart);

    onWeekChange?.({
      startDate: normalizedStart,
      endDate: normalizedEnd,
    });
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center" }}>
      <Button
        icon="chevronleft"
        stylingMode="contained"
        onClick={() => changeWeek(-1)}
      />

      <div style={{ fontWeight: "bold", minWidth: 240, textAlign: "center" }}>
        {formatDate(startDate)} - {formatDate(endDate)}
      </div>

      <Button
        icon="chevronright"
        stylingMode="contained"
        onClick={() => changeWeek(1)}
      />
    </div>
  );
}